import React, { useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Grid,
  Button,
  Chip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { clearDate, setDate } from "../../redux/dateSlice";
import { clearFilter, setFilterType } from "../../redux/voucher/voucherSlice";

const VoucherHeader = () => {
  const { filterType } = useSelector((state) => state.voucher);
  const { startDate, endDate } = useSelector((state) => state.date.date);
  const [branch, setBranch] = useState("");

  const dispatch = useDispatch();

  const voucherTypes = [
    { value: "all", label: "All" },
    { value: "medicine", label: "Medicine" },
    { value: "treatment", label: "Treatment" },
  ];

  const branches = [
    { value: "", label: "All Branches" },
    { value: "main", label: "Main Branch" },
    { value: "branch1", label: "Branch 1" },
    { value: "branch2", label: "Branch 2" },
    { value: "branch3", label: "Branch 3" },
  ];

  const handleFilterChange = () => {
    if (startDate && endDate) {
      dispatch(setFilterType({ startDate, endDate }));
    }
  };

  const handleStartDate = (e) => {
    dispatch(setDate({ startDate: e.target.value }));
  };

  const handleEndDate = (e) => {
    dispatch(setDate({ endDate: e.target.value }));
  };

  const handleVoucherType = (e) => {
    dispatch(setFilterType({ voucherType: e.target.value }));
  };

  const handleReset = () => {
    dispatch(clearFilter());
    dispatch(clearDate());
    setBranch("");
  };

  return (
    <Box sx={{ p: 3, bgcolor: "background.paper", borderRadius: 2, mb: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          mb: 2,
        }}
      >
        {/* First Group: Start Date, End Date, Search Button */}
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <TextField
            label="Start Date"
            type="date"
            value={startDate}
            onChange={handleStartDate}
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            label="End Date"
            type="date"
            value={endDate}
            onChange={handleEndDate}
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Button variant="contained" size="small" onClick={handleFilterChange}>
            Search
          </Button>
        </Box>

        {/* Second Group: Voucher Type, Reset Button */}
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <FormControl size="small">
            <InputLabel id="voucher-type-label">Voucher Type</InputLabel>
            <Select
              labelId="voucher-type-label"
              id="voucher-type"
              value={filterType?.voucherType}
              label="Voucher Type"
              onChange={handleVoucherType}
              sx={{ minWidth: 150 }}
            >
              {voucherTypes.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button variant="outlined" size="small" onClick={handleReset}>
            Reset
          </Button>
        </Box>
      </Box>

      {/* Active Filters Display */}
      {/* <Box sx={{ mt: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
        {voucherType !== "all" && (
          <Chip
            label={`Type: ${voucherTypes.find((t) => t.value === voucherType)?.label}`}
            size="small"
            onDelete={() => setVoucherType("all")}
          />
        )}
        {startDate && (
          <Chip
            label={`From: ${startDate.toLocaleDateString()}`}
            size="small"
            onDelete={() => setStartDate(null)}
          />
        )}
        {endDate && (
          <Chip
            label={`To: ${endDate.toLocaleDateString()}`}
            size="small"
            onDelete={() => setEndDate(null)}
          />
        )}
        {branch && (
          <Chip
            label={`Branch: ${branches.find((b) => b.value === branch)?.label}`}
            size="small"
            onDelete={() => setBranch("")}
          />
        )}
      </Box> */}
    </Box>
  );
};

export default VoucherHeader;
